import React from "react";
import { brandStory } from "./mock";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-image-bg">
        <img 
          src="/images/legacy-skincare-1.png" 
          alt="Ka Lā 'Alohi luxury skincare with tropical Hawaiian beach"
          className="hero-background-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-large">{brandStory.title}</h1>
            <p className="hero-subtitle">{brandStory.subtitle}</p>
            <p className="body-large hero-description">
              {brandStory.description}
            </p>

            <ul className="hero-trust-bar" data-testid="hero-trust-bar">
              <li><span aria-hidden="true">·</span> Handcrafted in Waiʻanae</li>
              <li><span aria-hidden="true">·</span> Small batch &amp; cruelty-free</li>
              <li><span aria-hidden="true">·</span> Reef-safe formulations</li>
              <li><span aria-hidden="true">·</span> Ships to all 50 states</li>
            </ul>
            
            <div className="hero-luxury-showcase">
              <img 
                src="/images/collection-hero.jpg"
                alt="Complete collection: Lokahi, Ka Lā 'Alohi, and Pō Mahina products on elegant wooden stand"
                className="luxury-showcase-image"
              />
            </div>
            
            <div className="hero-product-showcase">
              <div className="product-image-container">
                <img 
                  src="/images/img-0227.png" 
                  alt="Lokahi Yoga Mat Cleaner on palm leaf"
                  className="product-showcase-image"
                />
              </div>
              <div className="product-image-container">
                <img 
                  src="/images/img-0228.png" 
                  alt="Ka Lā 'Alohi body oil on sandy background"
                  className="product-showcase-image"
                />
              </div>
              <div className="product-image-container">
                <img 
                  src="/images/img-0229.png" 
                  alt="Pō Mahina magnesium spray under starry night"
                  className="product-showcase-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;